/**
 * Create a Date object representing midnight in local timezone from an ISO 8601-like date string
 * @param dateString - the input string in ISO 8601-like format where only the date portion is relevant
 * @returns a Date object representing midnight in local timezone
 */
export const createDateWithoutTimezone = (dateString: string) => {
  const [year, month, day] = dateString.slice(0, 10).split('-')
  // If you pass a date string to new Date(), it will be interpreted as UTC - we want local time
  // Month is 0-based
  return new Date(Number(year), Number(month) - 1, Number(day))
}

export const removeTimezoneFromDate = (date: Date) => {
  return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000)
}

export const parseDateStringWithoutTimezone = (input: unknown): Date | undefined => {
  if (input instanceof Date) {
    return input
  }

  if (typeof input !== 'string') {
    return undefined
  }

  return createDateWithoutTimezone(input)
}
